export const en = {
    'agency-login': 'Agency',
    'build-date': 'Report date',
    download: 'Download report',
    'end-date': 'End date',
    id: 'ID',
    link: 'Download report',
    'report-kind': 'Report type',
    'start-date': 'Start date',
    status: 'Status'
};
